<template>
  <div>
    <UserRow v-for="(user) in this.users" :key="user.id" :user="user" @deleteUser="deleteUser" />
  </div>
</template>

<script>

import UserRow from "@/components/admin/UserRow.vue"

export default {
  name: "UsersList",
  components: {
    UserRow
  },
  props: {
    users: {
      type: Array,
      required: true
    }
  },
  methods: {
    deleteUser(user) {
      this.$emit('deleteUser', user);
    }
  }
};

</script>

<style scoped></style>